import React from 'react';
import {Box, Grid, Typography} from "@mui/material";
import {useNavigate, useParams} from "react-router";
import EventItem from "./eventItem/EventItem";
import {getPlanListApi} from "../../../api/ClientApi";
import LazyLoading from "../../../components/Admin/LazyLoading/LazyLoading";
import Loading from "../../../components/Site/Loading/Loading";
import usePrograms from "./usePrograms";
import {useQuery, useQueryClient} from "react-query";
import {firstChild} from "../../../tools/helper";


const Programs = () => {
    const client = useQueryClient();
    const {programId} = useParams();
    const navigate = useNavigate();

    const getPlanList = async () => {
        try {
            let res = await getPlanListApi()
            return res?.data?.data;
        } catch (e) {
            // log error
        }
    }

    const queryKey = 'eventList_list_' + programId;
    const invalidateData = async () => {
        await client.invalidateQueries(queryKey);
    }

    const {data: eventList, isLoading, hasNextPage, fetchNextPage} = usePrograms(queryKey, programId)
    const {data: planList, isLoading: planIsLoading} = useQuery(['plan_list'], getPlanList)


    if (planIsLoading || isLoading) return <Loading/>

    // console.log('ppppppppppppppppppp',planList)
    return (

        <Grid container sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            width: '100vw',

        }}>
            <Grid sx={{
                background: '#F4F0F8', width: "100vw",
            }}>
                {/*<Typography>your id: {programId}</Typography>*/}
                <Box sx={{
                    flexDirection: 'column',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 32px 32px 32px',
                    margin: "auto",
                    height: '250px',
                }}>

                    <Typography sx={{
                        color: '#232536', fontWeight: 700,
                        fontSize: {md: '30px', sm: "25px", xs: '20px'}
                    }}>
                        {firstChild(eventList?.pages[0]?.result)?.plan?.name}
                    </Typography>

                    <Typography variant={"h5"} sx={{
                        color: '#6D6E76',
                        marginBottom: 5,
                        marginTop: 2,
                        letterSpacing: '0.5px'
                    }}>
                        نسخه خوب خود را پیدا کنید.
                    </Typography>

                </Box>
            </Grid>

            <Grid sx={{
                display: 'flex',
                flexDirection: {md: 'row', sm: "column", xs: "column"},
                width: "100vw",
                gap: 2,
                padding: {md: 4, xs: 0},
                mt: 4
            }}>
                <Grid sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    // justifyContent:'center',
                    alignItems: {md: 'self-start', xs: "center"},
                    gap: 1,
                }}>
                    <Typography variant={'h5'} sx={{fontWeight: 700, py: 2}}>دسته بندی ها</Typography>
                    {
                        planList?.map((plan, index) => (
                            <Grid key={index} onClick={() => navigate('/programs/' + plan.id)}
                                  sx={{
                                      minWidth: 150,
                                      width: "200px",
                                      minHeight: 60,
                                      fontWeight: 600,
                                      padding: 2,
                                      textAlign: "end",
                                      cursor: 'pointer',
                                      border: '1px solid #afafaf',
                                      background: programId == plan?.id ? '#FFD050' : 'none'
                                  }}
                                  variant={'outlined'}
                            >
                                {plan?.name}
                            </Grid>
                        ))
                    }
                </Grid>

                <Grid sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    textAlign: "left",
                    gap: 2,
                    width: '100vw',
                    flexGrow: 1,
                }}>

                    <LazyLoading loadingTxt={'loading...'} fetchNextPage={fetchNextPage} hasNextPage={hasNextPage}
                                 maxHeight={'100%'} width={'100%'}>

                        {/*{isLoading && <CustomerTabSkeleton/>}*/}
                        {isLoading && <Loading/>}
                        {
                            eventList?.pages?.map((pageResult, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        {
                                            pageResult?.result?.map((post, index) =>
                                                <React.Fragment key={index}>
                                                    <EventItem post={post}/>
                                                </React.Fragment>
                                            )
                                        }
                                    </React.Fragment>
                                )
                            })
                        }
                    </LazyLoading>
                </Grid>
            </Grid>
        </Grid>
    );

};

export default Programs;



